import { render, staticRenderFns } from "./Pdfs.vue?vue&type=template&id=77974b78&scoped=true"
import script from "./Pdfs.vue?vue&type=script&lang=js"
export * from "./Pdfs.vue?vue&type=script&lang=js"
import style0 from "./Pdfs.vue?vue&type=style&index=0&id=77974b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77974b78",
  null
  
)

export default component.exports